import { type SvgProps, SvgWrapper } from '../utils';
export function RedoIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M2.25 17C2.25 14.4141 3.27699 11.9339 5.10547 10.1055C6.93395 8.27699 9.41414 7.25 12 7.25H12.001C14.2504 7.25234 16.4253 8.03172 18.1602 9.44922L18.501 9.74121L18.502 9.74219L20.25 11.3154V7C20.25 6.58579 20.5858 6.25 21 6.25C21.4142 6.25 21.75 6.58579 21.75 7V13C21.75 13.4142 21.4142 13.75 21 13.75H15C14.5858 13.75 14.25 13.4142 14.25 13C14.25 12.5858 14.5858 12.25 15 12.25H19.0449L17.499 10.8584L17.2109 10.6113C15.7429 9.41178 13.9025 8.75194 11.999 8.75C9.81134 8.75026 7.71296 9.61907 6.16602 11.166C4.61884 12.7132 3.75 14.812 3.75 17C3.75 17.4142 3.41421 17.75 3 17.75C2.58579 17.75 2.25 17.4142 2.25 17Z" />
    </SvgWrapper>
  );
}
